export const NotFoundTestIds = {
  buttonBackToMain: 'button_backToMain'
} as const;
